import experiments from '@reverbdotcom/commons/src/experiments';
import { CoreMarketplaceCombinedMarketplaceSearch } from '../../schemas/rql';

export const ALWAYS_TRACKED_EXPERIMENTS = [
  experiments.LISTING_CARD_LOCATION,
  experiments.DUMMY,
  experiments.MARKETPLACE_GRID_ADS,
  experiments.LISTINGS_QUERY_REWRITE_V2,
  experiments.LISTINGS_SEARCH_BEST_MATCH_SIGNALS_V3,
  experiments.LTS_V3_MARKETPLACE,
  experiments.AA_MARKETPLACE_SESSION_BUCKETING,
  experiments.PRICE_DROP_FILTER,
];

export function pageViewTrackedExperiments(listingsSearchResult: CoreMarketplaceCombinedMarketplaceSearch.ListingsSearch): string[] {
  // Experiments that are always tracked in page view events
  const trackedExperiments = [].concat(ALWAYS_TRACKED_EXPERIMENTS);

  // Experiments that are conditionally tracked
  if (listingsSearchResult?.eligibleAutodirects?.length > 0) {
    trackedExperiments.push(experiments.DATA_DRIVEN_AUTODIRECTS_V2);
  }

  return trackedExperiments;
}
